import React from 'react';
import './style.scss';
import { noop } from 'lodash';

/**
 * FitPeopleLabel component - used inside fit and match modals.
 *
 * @param {Object} props - Props for the FitPeopleLabel component.
 * @param {string} props.container - The container type ('match' or empty string). Necessary to make MatchModal in Need Page work properly.
 * @param {React.ReactNode} props.children - The children elements.
 * @param {string} props.type - The type of the fit label ('fit', 'opt-match', or 'fit-opt-match').
 * @param {string} props.people - The people value ('people' or empty string). Necessary to make FitModal in Deallocation Page work properly. 
 * @returns {JSX.Element} The FitPeopleLabel component.
 * @example
 * <FitPeopleLabel type='fit'>
		...
	</FitPeopleLabel>
 */
const FitPeopleLabel = ({container, children, type, people }) => {
	let fitLabel = '';
	if (type === 'fit') fitLabel = 'FIT';
	else if (type === 'opt-match') fitLabel = 'OPT MATCH';
	else if (type === 'fit-opt-match') fitLabel = 'FIT + OPT MATCH';

	return (
		<div className={`${container === 'match' ? 'fit-people-label-match-container' : 'fit-people-label-container'} 
		${(fitLabel !== '' && people === '') ? `${type}-container` : ''}`}>
			<span className={`fit-people-label ${type}`}>{fitLabel}</span>
			<div>{children}</div>
		</div>
	);
};

FitPeopleLabel.defaultProps = {
  container: '', 
  children: noop, 
  type: '', 
  people: ''
};

export { FitPeopleLabel };
